module.exports = __webpack_public_path__ + "img/12fedfae806712b35ef9ba502ae1f6ad.png";